import { Component, computed, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormFieldService } from '../../../services/form-field/form-field.service';
import { LangService } from 'src/app/shared/services/lang/lang.service';
import { KeyUsages } from 'src/app/shared/entities/key-usages';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { KeyUsagesFormFieldOptions } from '../../../form-field.types';

@Component({
  selector: 'app-key-usage-form-field',
  imports: [ReactiveFormsModule, MatCheckboxModule, MatExpansionModule],
  templateUrl: './key-usage-form-field.component.html',
  styleUrl: './key-usage-form-field.component.scss',
})
export class KeyUsageFormFieldComponent {
  private formFieldService = inject(FormFieldService);
  private langService = inject(LangService);
  private openByDefault = true;

  title = this.langService.lang.shared.keyUsageTitle;
  criticalKeyUsageLabel = this.langService.lang.shared.criticalKeyUsageLabel;
  usageLabels: Record<KeyUsages, string> =
    this.langService.lang.shared.keyUsages;

  keyUsages = [
    KeyUsages.DIGITAL_SIGNATURE,
    KeyUsages.NON_REPUDIATION,
    KeyUsages.KEY_ENCIPHERMENT,
    KeyUsages.DATA_ENCIPHERMENT,
    KeyUsages.KEY_AGREEMENT,
    KeyUsages.KEY_CERT_SIGN,
    KeyUsages.CRL_SIGN,
    KeyUsages.ENCIPHER_ONLY,
    KeyUsages.DECIPHER_ONLY,
  ];

  name = input('');
  path = input<string>();
  options = input<KeyUsagesFormFieldOptions>();
  expanded = computed(() => {
    const open = this.options()?.open;
    return (open === undefined && this.openByDefault) || open;
  });

  formGroup = this.formFieldService.formGroup;
  control = computed(() => {
    const path = this.path() ?? this.name();
    const formGroup = this.formGroup();
    return formGroup?.get(path) as FormGroup;
  });
  keyUsagesGroup = computed(
    () => this.control()?.get('keyUsages') as FormGroup,
  );
}
